module.exports = __webpack_public_path__ + "img/25.dbf14814.jpg";